// Ritorna il grupppo principale se esiste, altrimenti torna il primo
export function getPrincipaleOPrimoGruppo(aggregate) {
	const principale = aggregate.find(ag => ag?.isPrincipale);
	/* 24/07/2026 rimosso l'ordinamento in quanto
	   1) Nel caso in cui conf.agrm === true va mantenuto l'ordinamento
	      base e non quello per ranking.
	   2) Le aggregate vengono già ordinate a monte, o almeno dovrebbero
	*/
	return principale || aggregate/*.sort(byRanking)*/[0];
}
